import { ClickFormsAdjustmentGridFieldsMap } from '../../types.ts';

export const ADD_COMPS_FORM_CODE = 'F363';
export const ADD_COMPS_1025_CODE = 'F364';
export const ADD_COMPS_1004C_FORM_CODE = 'F365';
export const ADD_COMPS_TOTAL_ROWS = 253;
export const ADD_COMPS_1025_TOTAL_ROWS = 334;
export const ADD_COMPS_1004C_TOTAL_ROWS = 259;
export const ADD_COMPS_ROWS_PER_COMP = 61;
export const ADD_COMPS_1025_ROWS_PER_COMP = 83;
export const ADD_COMPS_1004C_ROWS_PER_COMP = 63;

export const ADD_COMPS_ADJUSTMENT_FIELDS: ClickFormsAdjustmentGridFieldsMap = {
  salePrice: 52,
  saleFinanceAdj: 57,
  concAdj: 59,
  dateOfSaleAdj: 61,
  locationAdj: 63,
  propRightsAdj: 65,
  siteAdj: 67,
  viewAdj: 69,
  designAdj: 71,
  qualityAdj: 73,
  actualAgeAdj: 75,
  conditionAdj: 77,
  aboveGradeAdj: 78,
  roomCountAdj: 82,
  glaAdj: 84,
  basementLine1Adj: 86,
  basementLine2Adj: 88,
  funcUtilAdj: 90,
  heatingCoolingAdj: 92,
  energyEffAdj: 94,
  garageCarportAdj: 96,
  porchPatioAdj: 98,
  blank1Adj: 100,
  blank2Adj: 102,
  blank3Adj: 104,
};

export const ADD_COMPS_1004C_ADJUSTMENT_FIELDS: ClickFormsAdjustmentGridFieldsMap = {
  salePrice: 52,
  saleFinanceAdj: 59,
  concAdj: 61,
  dateOfSaleAdj: 63,
  locationAdj: 65,
  propRightsAdj: 67,
  siteAdj: 69,
  viewAdj: 71,
  designAdj: 73,
  qualityAdj: 75,
  actualAgeAdj: 77,
  conditionAdj: 79,
  aboveGradeAdj: 80,
  roomCountAdj: 84,
  glaAdj: 86,
  basementLine1Adj: 88,
  basementLine2Adj: 90,
  funcUtilAdj: 92,
  heatingCoolingAdj: 94,
  energyEffAdj: 96,
  garageCarportAdj: 98,
  porchPatioAdj: 100,
  blank1Adj: 102,
  blank2Adj: 104,
  blank3Adj: 106,
};

export const ADD_COMPS_1025_ADJUSTMENT_FIELDS: ClickFormsAdjustmentGridFieldsMap = {
  salePrice: 68,
  saleFinanceAdj: 80,
  concAdj: 82,
  dateOfSaleAdj: 84,
  locationAdj: 86,
  propRightsAdj: 88,
  siteAdj: 90,
  viewAdj: 92,
  designAdj: 94,
  qualityAdj: 96,
  actualAgeAdj: 98,
  conditionAdj: 100,
  gbaAdj: 102,
  unitBreakdownAdj: 103,
  unit1Adj: 107,
  unit2Adj: 111,
  unit3Adj: 115,
  unit4Adj: 119,
  basementLine1Adj: 121,
  basementLine2Adj: 123,
  funcUtilAdj: 125,
  heatingCoolingAdj: 127,
  energyEffAdj: 129,
  garageCarportAdj: 131,
  porchPatioAdj: 133,
  blank1Adj: 135,
  blank2Adj: 137,
  blank3Adj: 139,
};

export const ADD_COMPS_ROWS = {
  SU_BLANK1_LABEL: 42,
  SU_BLANK2_LABEL: 44,

  // COMP 1
  C1_NET_ADJ_POS_CHECKBOX: 105,
  C1_NET_ADJ_NEG_CHECKBOX: 106,
  C1_NET_ADJ_TOTAL: 107,
  C1_ADJ_SALE_PRICE: 108,
};

export const ADD_COMPS_1025_ROWS = {
  SU_BLANK1_LABEL: 58,
  SU_BLANK2_LABEL: 60,
};
